import React from 'react';
import { motion } from 'framer-motion';
import { Link, Route } from 'react-router-dom';

const MenuItem = ({
  to = null,
  onClick = null,
  activeOnlyWhenExact = false,
  Icon,
  label,
  tight = false,
  caption = null,
  textClass = 'text-jcap-200',
  activeTextClass = 'text-jcap-100',
  activeIndicatorClass = 'bg-jcap-800',
  pageMenuItem = false,
}) => {
  const classes = {
    li: 'cursor-pointer mx-4 text-sm',
    linkWrapper: [
      'absolute left-0 z-10 flex truncate overflow-hidden w-full flex items-center pl-3 select-none',
      tight ? 'h-8' : 'h-10',
    ],
    linkA: [
      'relative flex items-center p-4 font-semibold my-1',
      tight ? 'h-8' : 'h-10',
    ],
    linkIconWrapper: ['inline mr-3 mb-px w-5 h-5'],
    icon: ['inline mr-3 mb-1 p-px flex-shrink-0 w-5 h-5'],
    activeLinkBackground: [
      'absolute z-0 inset-0 rounded w-full pointer-events-none',
      activeIndicatorClass,
      tight ? 'h-8' : 'h-10',
    ],
  };

  if (!to)
    return (
      <li
        className={classes.li}
        // whileTap={{ scale: 0.95 }}
        onClick={onClick}
      >
        <div
          className={[classes.linkWrapper, classes.linkA, textClass].join(' ')}
        >
          {Icon && (
            <div className={classes.linkIconWrapper.join(' ')}>
              <Icon className={[classes.icon, textClass].join(' ')} />
            </div>
          )}
          <span className="truncate">{label}</span>
        </div>
      </li>
    );

  return (
    <Route
      path={to}
      exact={activeOnlyWhenExact}
      children={({ match: isActive }) => (
        <li
          className={classes.li}
          // whileTap={{ scale: 0.95 }}
        >
          <Link to={to} onClick={onClick} className={classes.linkA.join(' ')}>
            <div
              className={
                isActive
                  ? [classes.linkWrapper, activeTextClass].join(' ')
                  : [classes.linkWrapper, textClass].join(' ')
              }
            >
              {Icon && (
                <div className={classes.linkIconWrapper.join(' ')}>
                  <Icon
                    className={
                      isActive
                        ? [classes.icon, activeTextClass].join(' ')
                        : [classes.icon, textClass].join(' ')
                    }
                  />
                </div>
              )}
              <div className="flex flex-col">
                <div className="truncate">{label}</div>
                <div className="text-xs font-normal truncate">{caption}</div>
              </div>
            </div>
            {isActive &&
              (pageMenuItem ? (
                <div /* this is the background container */
                  className={classes.activeLinkBackground.join(' ')}
                />
              ) : (
                <motion.div /* this is the background container */
                  initial={{ scaleY: 0 }}
                  animate={{ scaleY: 1 }}
                  transition={{ duration: 0.2 }}
                  className={classes.activeLinkBackground.join(' ')}
                />
              ))}
          </Link>
        </li>
      )}
    />
  );
};

export default MenuItem;
